<template>
    <div class="custom-select">
        <div class="title" @click="showOptions = !showOptions">
            <span v-if="!selectedValue">{{placeholder}}</span>
            <span v-else class="selected-value">{{selectedValue}}</span>
        </div>
        <div class="options" :class="{'open': showOptions}">
            <div :id="id" class="option custom-option" :value="value" v-for="value in values" :key="value" @click="selectValue(value)">{{value}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props:["placeholder","values", "id", "name"],
    data(){return{
        showOptions: false,
        selectedValue: null
    }},
    methods:{
        selectValue(value){
            this.selectedValue = value
            this.$store.commit('SET_INPUT_VALUES', {name: this.name, value, workspaceId:localStorage.getItem("workspaceId")})
            this.showOptions = false
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-select{
    .title{
        width: 100%;
        padding: 3% 0;
        margin-top: 5%;
        border: none;
        border-bottom: 1px solid #858585;
        font-size: 19px;
        color: #858585;
        font-weight: 100;
        outline: none;
        &:hover{
            cursor: pointer;
        }
        .selected-value{
            color: #000;
            font-weight: 900;
        }
    }
    .options.open{
        max-height: 300px;
        overflow: overlay;
    }
    .options{
        max-height: 0;
        overflow: hidden;    
        transition: max-height .3s;  

        .option{
            padding: 10px;
            background-color: #fdfeff;
            border: 1px solid #ccc; 
            transition: background-color .1s;
            &:hover{
                cursor: pointer;
                background-color: #ececec;
            }     
        }
    }
}
</style>